export const buildFormData = (args) => {
  const { parameters, variantId, quantity } = args;
  const form = new FormData();
  form.append('variant_id', variantId);
  form.append('quantity', quantity);

  Object.keys(parameters).forEach((key) => {
    form.append(`parameters[${key}]`, parameters[key]);
  });

  return form;
};
